import { render, staticRenderFns } from "./AddMultiCheckboxes.vue?vue&type=template&id=33654268&scoped=true&"
import script from "./AddMultiCheckboxes.vue?vue&type=script&lang=js&"
export * from "./AddMultiCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./AddMultiCheckboxes.vue?vue&type=style&index=0&id=33654268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33654268",
  null
  
)

export default component.exports